import { c as _c } from "react/compiler-runtime";
import { CalendarCheck, XCircle } from '@phosphor-icons/react';
import { parseLocalDate } from '@utils/helpers';
import { formatDate, formatTime } from '@utils/utils-format';
import { DEFAULT_TIME_ZONE } from '@/lib/time-zone';
import { LineItem } from './line-item';
type CancelationPolicyProps = {
  cancelationDeadline?: string;
  cancelationTimezone?: string | null;
};
export function CancelationPolicy(t0) {
  const $ = _c(12);
  const {
    cancelationDeadline,
    cancelationTimezone
  } = t0;
  const zone = cancelationTimezone ?? DEFAULT_TIME_ZONE;
  let T0;
  let t1;
  let t2;
  if ($[0] !== cancelationDeadline || $[1] !== zone) {
    const deadline = cancelationDeadline ? parseLocalDate({
      local: cancelationDeadline,
      timezone: zone
    }) : null;
    const icon = cancelationDeadline ? CalendarCheck : XCircle;
    T0 = LineItem;
    t1 = icon;
    t2 = deadline && <span>{`Kostenlose Stornierung bis ${formatDate(deadline, zone)} um ${formatTime(deadline, zone)} Uhr`}</span>;
    $[0] = cancelationDeadline;
    $[1] = zone;
    $[2] = T0;
    $[3] = t1;
    $[4] = t2;
  } else {
    T0 = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== cancelationDeadline) {
    t3 = !cancelationDeadline && <span>Keine kostenlose Stornierung</span>;
    $[5] = cancelationDeadline;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <T0 icon={t1}>{t2}{t3}</T0>;
    $[7] = T0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}